export const redirectablePages = [
  '/earn-bitcoin/',
  '/farms/',
  '/staking/',
  '/pools/',
];
